import { useQuery, useQueryClient } from "@tanstack/react-query";

import { BACKEND_API } from "lib/env";
import { ServerPlan } from "lib/types";

import { generatePlansQueryKey } from "store/utils";

const fetchPlans = async (cityName: string) => {
  const response = await fetch(`${BACKEND_API}/api/plans?city=${cityName}`);

  if (!response.ok) {
    throw new Error("Plans network response was not ok");
  } else {
    // @ts-ignore
    return response.json() as ServerPlan[];
  }
};

export const usePlansQuery = (
  selectedCityName: string,
  initialData: ServerPlan[],
) => {
  const queryClient = useQueryClient();

  // @ts-ignore
  return useQuery<ServerPlan[], Error>(
    {
      queryKey: generatePlansQueryKey(selectedCityName),
      queryFn: async () => fetchPlans(selectedCityName),
      enabled: !!selectedCityName,
      initialData,
    },
    queryClient,
  );
};
